import { SET_ALTERNATE_EMAILS } from './actions';

const INITIAL_STATE = null;

const alternateEmailReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_ALTERNATE_EMAILS: {
               return action.payload;
          }
          default:
               return state;
     }
};

export default alternateEmailReducer;
